import { isNone } from '@ember/utils';

import Transform from '@ember-data/serializer/transform';

export default class ArrayTransform extends Transform {
	deserialize(serialized: unknown[] | null | undefined): unknown[] {
		return isNone(serialized) ? [] : serialized;
	}

	serialize(deserialized: unknown[] | null | undefined): unknown[] {
		return isNone(deserialized) ? [] : deserialized;
	}
}

declare module '@ember-data/serializer/transform' {
	export default interface TransformRegistry {
		array: unknown[];
	}
}
